<template>
	<div class="flex gap-2.5 items-center flex-wrap">
		<InventarisationCustomerSelect v-model="selectedId" :customers />

		<AppButton
			variant="ghost"
			icon="remove"
			aria-label="Verwijder klant"
			:disabled="!canRemove"
			@click="onRemoveClick"
		/>
		<AppButton
			variant="ghost"
			icon="add"
			aria-label="Voeg klant toe"
			:disabled="!canAdd"
			@click="onAddClick"
		/>
	</div>
</template>

<script lang="ts" setup>
import type {
	InventarisationCustomers,
	InventarisationCustomer,
} from "@loanlink-nl/model-app";
import { computed } from "vue";

interface Props {
	customers: InventarisationCustomers;
	maxEntries: number;
}

const emit = defineEmits<{
	add: [payload: void];
	remove: [payload: CustomerId];
}>();

const props = defineProps<Props>();

type CustomerId = InventarisationCustomer["id"];
const selectedId = defineModel<CustomerId | undefined>();

const canAdd = computed(() => {
	return props.customers.length < props.maxEntries;
});
const canRemove = computed(() => {
	return 0 <= props.customers.length && selectedId.value !== undefined;
});

function onAddClick() {
	if (canAdd.value) {
		emit("add");
	}
}

function onRemoveClick() {
	if (canRemove.value && selectedId.value !== undefined) {
		emit("remove", selectedId.value);
		selectedId.value = undefined;
	}
}
</script>
